import { detailViewColors, listViewColors } from './parts'

export interface VoicemailColors {
  ListView: typeof listViewColors
  DetailView: typeof detailViewColors
}

export const voicemailColors: VoicemailColors = {
  ListView: listViewColors,
  DetailView: detailViewColors,
}
